import { diContainer, serviceNames } from '../diContainer/diContainer';
import Store from '../domain/entities/Store/Store';
import AnalyticsRepository from '../repositories/AnalyticsRepository';
import BopisStoresRepository from '../repositories/BopisStoresRepository';
import TransactionRepository from '../repositories/TransactionRepository';

class SelectStoreUseCase {
  private store: Store;

  private prevStore: Store;

  private transactionRepository: TransactionRepository;

  private analyticsRepository: AnalyticsRepository;

  private bopisStoresRepository: BopisStoresRepository;

  constructor(store?: Store, prevStore?: Store) {
    this.store = store;
    this.prevStore = prevStore;
    this.transactionRepository = diContainer.get(serviceNames.transactionRepository);
    this.analyticsRepository = diContainer.get(serviceNames.analyticsRepository);
    this.bopisStoresRepository = diContainer.get(serviceNames.bopisStoresRepository);
  }

  public execute = async (): Promise<void> => {
    if (this.prevStore) {
      const { name, subHeading } = this.prevStore;
      const prevStoreName = name && subHeading && subHeading !== 'null' ? `${name} ${subHeading}` : name;
      this.analyticsRepository.bopisStoreChange(prevStoreName);
    } else {
      const selectedStoreName = this.store && this.store.name && this.store.subHeading && this.store.subHeading !== 'null' ? `${this.store.name} ${this.store.subHeading}` : `${this.store.name}`;
      this.analyticsRepository.bopisStoreSelect(selectedStoreName);
    }

    const transaction = await this.transactionRepository.getTransaction();
    const doorId = this.store && this.store.doorId;
    transaction.setBopisStore(doorId);
    const { setSelectedStore } = this.bopisStoresRepository.bopisStoresCollection;
    setSelectedStore(this.store);
  };
}

export default SelectStoreUseCase;
